import { ComponentPublicInstance, reactive } from "vue";

import { MessageService } from "../services/message-service";
import { Container } from "aurelia-dependency-injection";
import { ConversationRoomTypeEnum } from "../enums/ConversationRoomTypeEnum";
import { IConversationUser } from "../resources-vue/vue-interfaces/i-message";
import { SET_LOADING } from "../pages-vue/Common/LoadingIndicator/store/types";
import eventBus from "./eventBus";
import { isMobileScreenSize } from "./isMobileScreenSize";
import { useLoadingIndicator } from "../pages-vue/Common/LoadingIndicator/store/useLoadingIndicator";
import { AttendanceTypeEnum } from "../enums/AttendanceTypeEnum";
import { useCallStore } from "../pages-vue/MessageCenter/store/useCallStore";
import { ISetUserProfile } from "../resources-vue/vue-interfaces/messaging-service/i-user";
import { ProfileActivityStatusEnum } from "../enums/ChatUserProfileEnum";
import { useApp } from "../pages-vue/App/useApp";

import JitsiPage from "../pages-vue/JitsiPage/JitsiPage.vue";

interface IOptionalParams {
    users?: IConversationUser[];
    conversationRoomType?: ConversationRoomTypeEnum;
    roomName?: string;
}

export async function jitsiRoomHandler(
    $vInstance: ComponentPublicInstance,
    roomId: string,
    callStartTime: string,
    callControls: {
        audioEnabled: boolean;
        videoEnabled: boolean;
    },
    { users = [], conversationRoomType = 1, roomName = null }: IOptionalParams = {}
) {
    const messageService = Container.instance.get(MessageService);
    const loadingIndicator = useLoadingIndicator();
    const appStore = useApp();
    const callStore = useCallStore();

    const dialogData = reactive({
        roomInfo: null,
        users,
        meetingType: conversationRoomType,
        loading: true,
        callStartTime: callStartTime,
        callControls,
        roomName
    });

    eventBus.emit("dialogOpened", true);
    loadingIndicator[SET_LOADING](true);

    const result = await messageService.joinRoom(roomId);
    const statusPayload: ISetUserProfile = {
        login: appStore.loggedInUserDetails.loginId,
        userActivityStatus: ProfileActivityStatusEnum.InACall
    };
    await messageService.updateUserProfile(statusPayload);
    eventBus.emit("updateUserStatus");

    loadingIndicator[SET_LOADING](false);
    dialogData.roomInfo = result;
    dialogData.loading = false;

    const isMobile = isMobileScreenSize();

    $vInstance.$dialog.open(JitsiPage, {
        props: {
            modal: false,
            closeOnEscape: false,
            closable: false,
            contentStyle: {
                overflowX: "hidden",
                minWidth: isMobile ? "300px" : "600px",
                minHeight: "500px"
            },
            showHeader: true
        },
        data: dialogData,
        onClose: async () => {
            callStore.markAttendanceForUser(AttendanceTypeEnum.Leave);
            const payload: ISetUserProfile = {
                login: appStore.loggedInUserDetails.loginId,
                userActivityStatus: ProfileActivityStatusEnum.ResetActivity
            };
            await messageService.updateUserProfile(payload);
            eventBus.emit("updateUserStatus");
            eventBus.emit("dialogOpened", false);
        }
    });
}
